const formatter = new Intl.NumberFormat("en-US", {
	style: "currency",
	currency: "USD",
});

//calculate the signage of a value
export function calculateSignage(num: number): string {
	if (num >= 0) {
		return `-${formatter.format(Math.abs(num))}`;
	} else {
		return `+${formatter.format(Math.abs(num))}`;
	}
}
